import { required, email } from 'vuelidate/lib/validators'

export const inspiradoModel = {
  nombres: '',
  apellidos: '',
  edad: '',
  tipoIdentificacion: '',
  numeroIdentificacion: undefined,
  correo: '',
  telefono: undefined,
  pais: 'Colombia',
  departamento: null,
  municipio: null,
  direccion: '',
  genero: '',
  etnia: '',
  victima: false,
  discapacidad: false,
  lgbti: false,
  capacitacionRecibida: false
}

export const inspiradoModelValidations = (obj) => {
  const inspirado = {
    nombres: { required },
    apellidos: { required },
    edad: { required,
      validAge: () => obj.edad >= 7 && obj.edad <= 120
    },
    tipoIdentificacion: { required },
    numeroIdentificacion: {
      required,
      validDocument: () => obj.numeroIdentificacion >= 999 && obj.numeroIdentificacion <= 9999999999
    },
    telefono: { required },
    correo: { required, email },
    pais: { required },
    departamento: { required },
    municipio: { required },
    direccion: { required },
    genero: { required },
    etnia: { required }
  }
  return inspirado
}
